import { render, staticRenderFns } from "./LoginOrRegist.vue?vue&type=template&id=d10c152a&scoped=true"
import script from "./LoginOrRegist.vue?vue&type=script&lang=ts"
export * from "./LoginOrRegist.vue?vue&type=script&lang=ts"
import style0 from "./LoginOrRegist.scss?vue&type=style&index=0&id=d10c152a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10c152a",
  null
  
)

export default component.exports